import React from 'react';
import '../styles/Footer.css';

import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaInstagram } from 'react-icons/fa';

const Footer = () => (
  <footer className="footer">
    <p>&copy; {new Date().getFullYear()} CVEY Solutions. All rights reserved.</p>
    <div className="social-icons">
      <a href="#"><FaFacebookF /></a>
      <a href="#"><FaTwitter /></a>
      <a href="#"><FaLinkedinIn /></a>
      <a href="#" aria-label="YouTube"><FaYoutube /></a>
      <a href="#" aria-label="Instagram"><FaInstagram /></a>
    </div>
    <p>
      D.No: 1-180, Siddanthi Street, S. Atchuthapuram New Colony, Kakinada, AP - 533004<br />
      <a href="mailto:kvrsnsg@cveysolutions.in" style={{ color: '#fff', textDecoration: 'underline' }}>
        kvrsnsg@cveysolutions.in
      </a>
    </p>

  </footer>
);

export default Footer;
